import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { SectionRenderer } from './SectionRenderer';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Published builder sections for a coded product page (rendered below the coded hero/benefits).
export const ProductCmsContent = ({ slug, children }) => {
  const [sections, setSections] = useState([]);
  useEffect(() => {
    setSections([]);
    axios.get(`${API_URL}/website/page/${slug}`, { params: { optional: 1 } }).then((r) => setSections(r.data.sections || [])).catch(() => {});
  }, [slug]);
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash || !sections.length) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
    return () => clearTimeout(t);
  }, [hash, sections]);
  if (!sections.some((s) => ['product_content', 'product_topic', 'room_guide', 'faq'].includes(s.type))) return null;
  return <div className="cms-root guide-safe" data-testid="product-cms-content"><SectionRenderer sections={sections} />{children}</div>;
};
